import React, { ReactNode } from 'react';

import './Tooltip.scss';

type Props = {
	children: ReactNode;
	content: string | JSX.Element;
	containerClassName?: string;
	contentClassName?: string;
	position?: 'top' | 'bottom' | 'left' | 'right';
	size?: 'md' | 'lg';
	longerBubble: boolean;
};

const Tooltip = ({
	children,
	content,
	position = 'top',
	size,
	containerClassName,
	contentClassName,
	longerBubble
}: Props): JSX.Element => {
	const positionClasses = () => {
		switch (position) {
			case 'top':
				return 'pb-3 bottom-full left-1/2 -translate-x-1/2';

			case 'right':
				return 'pl-3 left-full top-1/2 -translate-y-1/2';

			case 'bottom':
				return 'pt-3 top-full left-1/2 -translate-x-1/2';

			default:
				return '';
		}
	};

	return (
		<span
			className={`tooltip relative${
				containerClassName ? ` ${containerClassName}` : ''
			}`}
		>
			<span
				className={`absolute z-150 transform ${positionClasses()}${
					contentClassName ? ` ${contentClassName}` : ''
				}`}
			>
				<span
					className={`tooltip-content relative p-2 break-words${
						size ? `p-4 size-${size} ` : 'px-3 py-2'
					}shadow-xl position-${position} rounded text-base ${longerBubble ? 'longer-bubble' : ''}`}
				>
					{content}
				</span>
			</span>
			{children}
		</span>
	);
};

export default Tooltip;
